import React from 'react'
import utils from '../../utils'
import { Link } from 'react-router-dom'
import { LuArrowUpRight } from "react-icons/lu";

function CategoryItem(props) {
    const category = props.category

    return (
        <Link
            to={`/houses?category__slug=${category?.slug}`}
            className="group relative block bg-white rounded-3xl overflow-hidden border border-outline-variant/10 shadow-sm hover:shadow-2xl hover:shadow-primary/10 transition-all duration-500"
        >
            <div className="aspect-[4/5] overflow-hidden">
                <img
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                    src={utils.baseUrl + category?.image}
                    alt={category?.name}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity" />
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <div className="flex justify-between items-end">
                    <div>
                        <h3 className="text-xl font-headline font-black tracking-tight leading-none">
                            {category?.name}
                        </h3>
                    </div>

                    <div className="bg-white/10 backdrop-blur-md p-3 rounded-2xl border border-white/20 group-hover:bg-primary group-hover:border-primary transition-all duration-300">
                        <LuArrowUpRight size={20} className="text-white" />
                    </div>
                </div>
            </div>
            <div className="absolute top-4 right-4 h-px w-0 bg-white/40 group-hover:w-12 transition-all duration-500" />
        </Link>
    )
}

export default CategoryItem